
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({

    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    header: {
        background: '#ECF2FF',
        display: 'flex',
        alignItems: 'center',
        padding: "0 15px",
        height: '58px',
        "& h2": {
            padding: '0px 15px',
            // fontSize: '22px',
            // fontWeight: 600,
            // lineHeight: '28.8px',
            // color: '#2D4D95',
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 600,
             fontSize: window.isMobileView ? window.isMobile425 ? 14:18:24,
            lineHeight: '29px',
            color: '#2D4D95',
        }
    },
    container: {
        padding: '10px',
        paddingBottom: window.isIpadView ? '100px': '10px',
    },
    greyBorderBox: {
        border: '1px solid #e3e3e3',
        padding: '20px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        margin: '5px',
        flexFlow: 'column',
        minHeight: window.isMobileView? '226px':'270px',
        borderRadius: '19px',
        "& h3": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: window.isMobileView? '19px':'24px',
            lineHeight: window.isMobileView? 'initial':'39px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: '#3C4549',
            margin: '18px 0px',
        },
        "& img": {
            marginTop: '20px',
            width: window.isMobileView? '70px': '',
        }
    }

}))